export default {
  展览: 'Exhibitions',
  展览状态: 'Exhibition status',
  历史展览: 'Past Exhibitions',
  发布记录: 'Post History',
  上传照片: 'Add Photos',
  已上架产品: 'Exhibits',
  展览云图: 'Cloud Picture',
  导读简介: 'Introduction',
  请输入展览导读简介: 'Please enter an event introduction',
  '请输入展览导读简介,最多可输入1200个字符(600个汉字)': 'Please enter an event introduction within 600 characters',
  范围标签: 'Tag',
  添加新标签: 'Add Tag',
  '内容...': 'Content...',
  '距开幕,还有': 'The Event Will Start in',
  '距闭幕,还有': 'The Event will end in',
}
